import { ITicketProductWithBundleType } from '@nx-ng/types';
import { IFaresState } from '../../../reducers/fares';

export const formatFaresWithBundleType = (
  fares: IFaresState | undefined
): ITicketProductWithBundleType[] => {
  const flexiFares: ITicketProductWithBundleType[] =
    fares?.flexi?.fares?.map((fare) => ({ ...fare, bundleType: 'flexible' })) ||
    [];

  const paygFares: ITicketProductWithBundleType[] =
    fares?.payg?.fares?.map((fare) => ({
      ...fare,
      bundleType: 'payAsYouGo',
    })) || [];

  const searchFares: ITicketProductWithBundleType[] =
    fares?.search?.fares?.map((fare) => ({
      ...fare,
      bundleType: 'ticketOrPass',
    })) || [];

  return [...flexiFares, ...paygFares, ...searchFares];
};
